/* app/js/src/components/common/capsule/capsule.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  background-color: #ffffff;
  font-size: 0.8em;
  padding: 0.3em 0.3em 0.25em 0.7em;
  border-radius: 1.5em;
  display: inline-block;
  text-align: center;
  cursor: default;
  margin: 0 0.5em;
  opacity: 0.2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
}
:host span:last-child {
  font-size: 0.8em;
  margin-left: 0.5em;
  display: inline-block;
  width: 1.5em;
  background-color: #f5f9fd;
  height: 1.5em;
  border-radius: 50%;
  padding: 0.3em;
  color: #232f3a;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host span:last-child.included {
  background-color: #61b965;
  color: #ffffff;
}
:host.visible {
  opacity: 1;
}
:host.clickable span:last-child {
  cursor: pointer;
}
:host.clickable span:last-child:hover {
  -ms-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
/*# sourceMappingURL=capsule.component.css.map */
